import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class DestaqueNoticias1 {
    constructor() {
        this.sections = document.querySelectorAll('.component-destaques_noticias1');

        this.btnPlay = document.querySelectorAll('.openModalVideo')
        
        this.modal = document.querySelector('.modal--video')
        this.iframeModal = this.modal.querySelector('iframe')

        this.ready();

        if(this.btnPlay.length > 0) {
            this.modalVideo()
        }
    }

    ready() {

        this.sections.forEach(section => {
            const slider = section.querySelector('.swiper')
            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                allowTouchMove: true,
                loop: false,
                navigation: {
                    nextEl: section.querySelector('.slider-button-next'),
                    prevEl: section.querySelector('.slider-button-prev'),
                },
                pagination: {
                    el: section.querySelector('.swiper-pagination-nav'),
                    type: 'fraction',
                    renderFraction: (currentClass, totalClass) => {
                        return `
                            <span class="${currentClass}"></span> /
                            <span class="${totalClass}"></span>
                        `;
                    },
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 24,
                        slidesOffsetBefore: 24,
                        slidesOffsetAfter: 24,
                    },
                    1270: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    }
                },
                on: {
                    init: function () {
                        DestaqueNoticias1.formatPagination(section);
                    },
                    slideChange: function () {
                        DestaqueNoticias1.formatPagination(section);
                    },
                }
            });
        })

    }

    modalVideo() {
        
        this.btnPlay.forEach((item, k) => {
            item.addEventListener('click', (event) => {
                const yid = event.currentTarget.getAttribute('data-yid');
                this.iframeModal.setAttribute('src', `${yid}`);
                this.modal.classList.add('active')
            });
        });
        
        this.modal.querySelector('.modal--video .btnCloseModal').addEventListener('click', () => {
            this.modal.classList.remove('active')
            this.iframeModal.setAttribute('src', 'about:blank');
        });
        
    }

    static formatPagination(section) {
        const currentElement = section.querySelector('.swiper-pagination-nav .swiper-pagination-current');
        const totalElement = section.querySelector('.swiper-pagination-nav .swiper-pagination-total');

        if (currentElement) {
            currentElement.textContent = currentElement.textContent.padStart(2, '0');
        }
        if (totalElement) {
            totalElement.textContent = totalElement.textContent.padStart(2, '0');
        }
    }

}

if (document.querySelector('.component-destaques_noticias1')) {
    new DestaqueNoticias1();
}